<div class="row" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>

<div class="container" *ngIf="!loading && surveyDashboard">
  <ng-container *ngFor="let key of objectKeys(surveyDashboard)">
    <div class="container-fluid accordion-container accordion-inner"
         *ngIf="surveyDashboard[key]?.questions.data?.length > 0">
      <mat-accordion class="accordion" >
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ "service.survey-service.question-typologies." + (key | lowercase) + ".title" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>


          <!-- Mostra tabella solo se ci sono elementi -->
          <div>

            <div echarts [options]="surveyCharts[key]" class="chart w-100 my-4"></div>

            <div class="box py-0 px-2 bg-transparent border-0 mb-0 text-center">
              <mat-label class="box-title px-3 mb-0">{{ 'generic.filters' | translate }}</mat-label>
            </div>

            <div class="card p-3 mb-3">
              <div class="row justify-content-around">
                <div class="col-lg-6 col-12 text-center pb-4">
                  <!-- Label centrata sopra gli slider -->
                  <label class="form-label fw-bold d-block mb-2">
                    {{ "components.responses.consensus.agree" | translate }} (%)
                  </label>

                  <!-- Primo slider -->
                  <mat-slider
                    min="0"
                    max="100"
                    step="1"
                    [displayWith]="formatPercent"
                    thumbLabel
                    [value]="filters.agree[0]"
                    (input)="updateFilter(key, 'agree', $event.value, 0)">
                  </mat-slider>

                  <!-- Secondo slider -->
                  <mat-slider
                    class="slider-primary"
                    min="0"
                    max="100"
                    step="1"
                    [displayWith]="formatPercent"
                    thumbLabel
                    [value]="filters.agree[1]"
                    (input)="updateFilter(key, 'agree', $event.value, 1)">
                  </mat-slider>
                </div>


                <!-- Filter: Certainty -->
                <div class="col-lg-6 col-12 text-center border-left-grey pb-4">
                  <!-- Label centrata sopra gli slider -->
                  <label class="form-label fw-bold d-block mb-2">
                    {{ "generic.certainty-degree" | translate }} (%)
                  </label>

                  <!-- Primo slider -->
                  <mat-slider
                    min="0"
                    max="100"
                    step="1"
                    [displayWith]="formatPercent"
                    thumbLabel
                    [value]="filters.certainty[0]"
                    (input)="updateFilter(key, 'certainty', $event.value, 0)">
                  </mat-slider>

                  <!-- Secondo slider -->
                  <mat-slider
                    class="slider-primary"
                    min="0"
                    max="100"
                    step="1"
                    [displayWith]="formatPercent"
                    thumbLabel
                    [value]="filters.certainty[1]"
                    (input)="updateFilter(key, 'certainty', $event.value, 1)">
                  </mat-slider>
                </div>

                <!-- Filter: Contradiction -->
                <div class="col-lg-6 col-12 mb-3 text-center border-bottom-grey pb-4">
                  <!-- Label centrata sopra gli slider -->
                  <label class="form-label fw-bold d-block mb-2">
                    {{ "components.responses.consensus.disagree" | translate }} (%)
                  </label>

                  <!-- Primo slider -->
                  <mat-slider
                    min="0"
                    max="100"
                    step="1"
                    [displayWith]="formatPercent"
                    thumbLabel
                    [value]="filters.disagree[0]"
                    (input)="updateFilter(key, 'disagree', $event.value, 0)">
                  </mat-slider>

                  <!-- Secondo slider -->
                  <mat-slider
                    class="slider-primary"
                    min="0"
                    max="100"
                    step="1"
                    [displayWith]="formatPercent"
                    thumbLabel
                    [value]="filters.disagree[1]"
                    (input)="updateFilter(key, 'disagree', $event.value, 1)">
                  </mat-slider>
                </div>

                <div class="col-lg-6 col-12 mb-3 text-center border-left-grey border-bottom-grey pb-4">
                  <!-- Label centrata sopra gli slider -->
                  <label class="form-label fw-bold d-block mb-2">
                    {{ "generic.contradiction-degree" | translate }} (%)
                  </label>

                  <!-- Primo slider -->
                  <mat-slider
                    min="0"
                    max="100"
                    step="1"
                    [displayWith]="formatPercent"
                    thumbLabel
                    [value]="filters.contradiction[0]"
                    (input)="updateFilter(key, 'contradiction', $event.value, 0)">
                  </mat-slider>

                  <!-- Secondo slider -->
                  <mat-slider
                    class="slider-primary"
                    min="0"
                    max="100"
                    step="1"
                    [displayWith]="formatPercent"
                    thumbLabel
                    [value]="filters.contradiction[1]"
                    (input)="updateFilter(key, 'contradiction', $event.value, 1)">
                  </mat-slider>
                </div>

                <ng-container class="mt-5">
                  <div class="col-lg-4 mb-3 col-12 align-items-center">
                    <mat-form-field class="select-primary w-100" appearance="fill">
                      <mat-label>{{ 'generic.section-filter' | translate }}</mat-label>
                      <mat-select name="filter_section"
                                  (selectionChange)="updateSectionFilter(key, $event.value)">
                        <mat-option value="">{{ "generic.all" | translate }}</mat-option>
                        <mat-option *ngFor="let sec of keyQuestionsSections(key)"
                                    [value]="sec">
                          {{ sec }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4 mb-3 col-12 align-items-center">
                    <mat-form-field class="select-primary w-100" appearance="fill">
                      <mat-label>{{ 'generic.preliminary-round-assessment-filter' | translate }}</mat-label>
                      <mat-select name="filter_section"
                                  [multiple]="true"
                                  (selectionChange)="updateStatusFilter(key, $event.value)">
                        <mat-option *ngFor="let sec of keyQuestionsStatuses(key)"
                                    [value]="sec">
                          {{ "components.surveys.survey-dashboard.survey-dashboard.component." + (sec | lowercase) | translate }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ng-container>
              </div>
            </div>

            <table mat-table [dataSource]="surveyDashboard[key]?.questions"
                   class="mat-elevation-z8 w-100 my-4 table table-bordered"
                   style="table-layout: fixed;">

              <!-- Statement -->
              <ng-container matColumnDef="section">
                <th mat-header-cell *matHeaderCellDef
                    class="text-center align-middle"> {{ "generic.section" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center align-middle">
                  {{ element.section || 'N/A' }}
                </td>
              </ng-container>

              <!-- Statement -->
              <ng-container matColumnDef="statement">
                <th mat-header-cell *matHeaderCellDef
                    class="text-center align-middle"> {{ "generic.statement" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center align-middle">
                  {{ element.statement }}
                </td>
              </ng-container>

              <!-- Votes -->
              <ng-container matColumnDef="votes">
                <th mat-header-cell *matHeaderCellDef
                    class="text-center align-middle"> {{ "generic.votes" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center align-middle">
                  <div class="d-flex flex-column justify-content-center align-items-center">
                  <span class="vote-item">✅ {{ element.agree_count }} ({{ element.agree_perc | number:'1.0-2' }}
                    %)</span>
                    <span class="vote-item">❌ {{ element.disagree_count }} ({{ element.disagree_perc | number:'1.0-2' }}
                      %)</span>
                    <span class="vote-item" *ngIf="!element.required">⏸️ {{ element.abstained_count }}
                      ({{ element.abstained_perc | number:'1.0-2' }}%)</span>
                  </div>
                </td>

              </ng-container>
              <!-- Consensus Indexes -->
              <ng-container matColumnDef="consensus_indexes">
                <th mat-header-cell *matHeaderCellDef
                    class="text-center align-middle"> {{ "geneneric.consensus-indexes" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center align-middle">
                  <div>
                    <strong>Certainty:</strong> {{ element.certainty_degree | number:'1.0-2' }}%
                  </div>
                  <div>
                    <strong>Contradiction:</strong> {{ element.contradiction_degree | number:'1.0-2' }}%
                  </div>
                </td>
              </ng-container>

              <!-- Status -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef
                    class="text-center align-middle"> {{ "generic.preliminary-round-assessment" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center align-middle">
                  <mat-chip selectable="true"
                            (click)="element.showSubtitle = !element.showSubtitle"
                            selected="true"
                            style="justify-content:center; pointer-events:none;"
                            class="text-white w-100"
                            [ngStyle]="{

              'background-color': element.status === 'ACCEPTED' ? '#00bc1d' :
                                 element.status === 'REJECTED' ? '#ff0000' : '#FFAD4A'
            }">
                    {{
                      (element.status === 'REJECTED' || element.status === 'ACCEPTED'
                          ? "components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)
                          : "components.surveys.survey-dashboard.survey-dashboard.component.to_revision"
                      ) | translate
                    }}
                  </mat-chip>
                </td>
              </ng-container>

              <!-- Hint -->
              <ng-container matColumnDef="hint">
                <th mat-header-cell *matHeaderCellDef class="text-center align-middle">
                  {{ "generic.hint" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center align-middle">
                  <b>
                    {{ ("components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)) + ".title" | translate }}
                  </b>
                  <br>
                  <!-- See details più piccolo -->
                  <b
                    style="cursor: pointer; font-size: 0.8em; color: #7B55C8"
                    (click)="element.showSubtitle = !element.showSubtitle"
                  >
                    see details
                  </b>
                  <!-- Subtitle, visibile solo se showSubtitle è true -->
                  <span *ngIf="element.showSubtitle">
      <br>
                    {{ ("components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)) + ".subtitle" | translate }}
    </span>
                </td>
              </ng-container>

              <!-- AI Revision Proposal -->
              <ng-container matColumnDef="ai_revision_proposal">
                <th mat-header-cell *matHeaderCellDef class="text-center align-middle"> AI Revision Proposal</th>
                <td mat-cell *matCellDef="let element" class="text-center align-middle">
                  N/A
                </td>
              </ng-container>

              <ng-container matColumnDef="final_decision">
                <th mat-header-cell *matHeaderCellDef class="text-center align-middle"> Final Decision</th>
                <td mat-cell *matCellDef="let element" class="text-center align-middle">
                  <div class="d-flex flex-column">
                    <ng-container *ngFor="let status of surveyService.questionFinalDecisionStatuses">
                      <button
                        [disabled]="survey?.is_revised"
                        (click)="setFinalDecision(element, status.id)"
                        mat-button class="my-2 btn btn-block text-wrap final-decision-button" mat-raised-button
                        *ngIf="!element.final_decision || element.final_decision === status.id"
                        [ngStyle]="{ 'background-color': status.bgcolor, 'color': 'white', 'width': '100%' }"
                      >
                        <mat-icon style="margin-right: 2px; color: #e0ffe0;">{{ status.icon }}</mat-icon>
                        <small>{{ survey?.is_revised ? status.title : status.titleNoRev }}</small>
                      </button>
                    </ng-container>
                  </div>
                </td>
              </ng-container>

              <!-- Header & Rows -->
              <tr mat-header-row *matHeaderRowDef="consensusDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: consensusDisplayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 20, 50]"
                           showFirstLastButtons>
            </mat-paginator>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </ng-container>
  <div class="row justify-content-center" *ngIf="!survey?.is_revised">
    <button
      class="btn-custom text-white my-5"
      mat-flat-button
      [disabled]="previewLoading"
      (click)="previewSurveyRevision()"
    >
      <mat-spinner
        *ngIf="previewLoading"
        diameter="20"
        strokeWidth="3"
        class="button-spinner">
      </mat-spinner>

      <span *ngIf="!previewLoading">{{ 'modals.modal-survey-details.review-survey' | translate }}</span>
    </button>
  </div>
</div>
